import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { CountdownComponent } from './countdown.component';

@NgModule({
  declarations: [CountdownComponent],
  imports: [CommonModule, PipesModule],
  exports: [CountdownComponent],
})
export class CountdownModule {}
